import { cva } from '@vizit/theme';

const rowClasses = cva({
  base: [
    'group bg-white transition-all duration-150',
    'focus-visible:outline-none',
    '[&[data-focus-visible]]:outline-2 [&[data-focus-visible]]:outline [&[data-focus-visible]]:outline-brand-600 [&[data-focus-visible]]:outline-offset-[-2px]',
    'cursor-pointer hover:ring-1 hover:ring-inset hover:ring-brand-600 hover:z-10 hover:relative',
  ],
  variants: {
    disabled: {
      false: '',
      true: 'cursor-not-allowed hover:ring-0',
    },
  },
});

export { rowClasses };
